export const styles = {
  exitDoorEditCtn: {
    marginBottom: "40px",
  },
  inputCtn: {
    display: "inline-block",
    width: "400px",
    "& > div": {
      marginTop: "5px !important",
    },
  },
};
